var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "transparent",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-14h-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5l14 1l-1 7h-13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartPlus);
export default __webpack_public_path__ + "static/media/cart-plus.7720518fee9533c9635cafe179958cf1.svg";
export { ForwardRef as ReactComponent };